/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_fr_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes. Enable 'Regular expression' to use patterns like \\d+ and backreferences such as $1 in the replacement. Invalid patterns show an error instead of changing your text.`)
};

const es_fr_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sí. Activa 'Expresión regular' para usar patrones como \\d+ y referencias anteriores como $1 en el reemplazo. Los patrones inválidos muestran un error en lugar de cambiar tu texto.`)
};

const de_fr_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja. Aktivieren Sie „Regulärer Ausdruck”, um Muster wie \\d+ und Rückverweise wie $1 in der Ersetzung zu verwenden. Ungültige Muster zeigen einen Fehler an, anstatt Ihren Text zu ändern.`)
};

const nl_fr_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja. Schakel 'Reguliere uitdrukking' in om patronen zoals \\d+ en terugverwijzingen zoals $1 in de vervanging te gebruiken. Ongeldige patronen tonen een fout in plaats van uw tekst te wijzigen.`)
};

const fr_fr_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oui. Activez « Expression régulière » pour utiliser des modèles comme \\d+ et des références arrière telles que $1 dans le remplacement. Les modèles invalides affichent une erreur au lieu de modifier votre texte.`)
};

const it_fr_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sì. Abilita 'Espressione regolare' per utilizzare modelli come \\d+ e retroriferimnti come $1 nella sostituzione. I modelli non validi mostrano un errore invece di modificare il tuo testo.`)
};

const pt_br2_fr_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim. Ative 'Expressão regular' para usar padrões como \\d+ e referências anteriores como $1 na substituição. Padrões inválidos mostram um erro em vez de alterar seu texto.`)
};

const pt_fr_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim. Ative 'Expressão regular' para usar padrões como \\d+ e referências anteriores como $1 na substituição. Padrões inválidos mostram um erro em vez de alterar o seu texto.`)
};

const ja_fr_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`はい。「正規表現」を有効にして、\\d+ などのパターンと置換の $1 などの後方参照を使用できます。無効なパターンはテキストを変更する代わりにエラーを表示します。`)
};

const zh_fr_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`是的。启用“正则表达式”即可使用像 \\d+ 这样的模式，以及在替换内容中使用 $1 这样的反向引用。无效的模式会显示错误提示，而不会更改你的文本。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const fr_faq1_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.fr_faq1_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("fr_faq1_a", locale)
	if (locale === "en") return en_fr_faq1_a(inputs)
	if (locale === "es") return es_fr_faq1_a(inputs)
	if (locale === "de") return de_fr_faq1_a(inputs)
	if (locale === "nl") return nl_fr_faq1_a(inputs)
	if (locale === "fr") return fr_fr_faq1_a(inputs)
	if (locale === "it") return it_fr_faq1_a(inputs)
	if (locale === "pt-BR") return pt_br2_fr_faq1_a(inputs)
	if (locale === "pt") return pt_fr_faq1_a(inputs)
	if (locale === "ja") return ja_fr_faq1_a(inputs)
	return zh_fr_faq1_a(inputs)
};